import { Box, Button, Grid } from '@mui/material';

interface StepNavigatorFooterProps {
    step: number;
    setStep: (step: number) => void;
    onCancel: () => void;
    onSubmit: () => void;
    onSaveDraft: () => void;
    onNext?: () => void;
    isNextDisabled?: boolean;
    isView?: boolean;
    formData?: any;
    isNextLoading?: boolean;
    idAvisoObra?: number | null;
    isSavingDraft?: boolean;
}

const StepNavigatorFooter = ({
    step,
    setStep,
    onCancel,
    onSubmit,
    onSaveDraft,
    onNext,
    isNextDisabled = false,
    formData,
    isNextLoading,
    idAvisoObra,
    isView = false
}: StepNavigatorFooterProps) => {
    const handleBack = () => setStep(step - 1);
    const handleNext = () => {
        if (onNext) return onNext();
        setStep(step + 1);
    };

    const handleCancel = () => {
        if (isView) {
            window.history.back();
        } else {
            onCancel();
        }
    };

    return (
        <Box sx={{ mt: 'auto', pb: 3 }}>
            <Grid container justifyContent="space-between">
                <Grid item>
                    {step === 1 ? (
                        <Button variant="outlined" onClick={handleCancel}>
                            Cancelar
                        </Button>
                    ) : (
                        <Button variant="outlined" onClick={handleBack}>
                            Volver
                        </Button>
                    )}
                </Grid>

                <Grid item>
                    <Grid container spacing={2}>
                        {!isView && ((step === 1 && idAvisoObra != null) || step > 1) && (
                            <Grid item>
                                <Button variant="outlined" onClick={onSaveDraft}>
                                    Guardar Borrador
                                </Button>
                            </Grid>
                        )}

                        {!isView && (
                            <Grid item>
                                {step === 3 ? (
                                    <Button
                                        variant="contained"
                                        onClick={onSubmit}
                                        disabled={isNextDisabled}
                                    >
                                        Enviar
                                    </Button>
                                ) : (
                                    <Button
                                        variant="contained"
                                        onClick={handleNext}
                                        disabled={isNextDisabled || isNextLoading}
                                    >
                                        {isNextLoading ? 'Cargando...' : 'Siguiente'}
                                    </Button>
                                )}
                            </Grid>
                        )}

                        {isView && step < 3 && (
                            <Grid item>
                                <Button variant="contained" onClick={handleNext}>
                                    Siguiente
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

export default StepNavigatorFooter;
